module.exports = __webpack_public_path__ + "static/media/tietosuojaseloste.b29151b8.pdf";